import React from 'react';

const SectionTitle = ({ 
  title, 
  subtitle, 
  centered = true, 
  className = '' 
}) => {
  const containerClasses = centered ? 'text-center' : 'text-left';
  
  return (
    <div className={`${containerClasses} ${className}`}>
      {subtitle && (
        <p className="text-sm font-semibold text-slate-800 uppercase tracking-wide mb-2 animate-fade-in">
          {subtitle}
        </p>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl logo-font text-gray-900 mb-4 animate-slide-up">
        {title}
      </h2>
    </div>
  );
};

export default SectionTitle;
